module.exports = __webpack_public_path__ + "img/tks.c5874a66.svg";